"use client";

import type { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export const VIEW_GUEST_SESSION_REASON = "View guests can't start sessions.";

/** Disabled controls still have a focusable, hoverable explanation. */
export function ViewGuestSessionTooltip({ disabled, children }: { disabled: boolean; children: ReactNode }) {
  if (!disabled) return children;
  return (
    <Tooltip>
      <TooltipTrigger render={<div tabIndex={0} />} className="min-w-0"
        aria-label={VIEW_GUEST_SESSION_REASON} title={VIEW_GUEST_SESSION_REASON}>
        {children}
      </TooltipTrigger>
      <TooltipContent>{VIEW_GUEST_SESSION_REASON}</TooltipContent>
    </Tooltip>
  );
}
